import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CalendarIcon, ClockIcon, MapPinIcon } from "lucide-react";
import SeoHelmet from "./SeoHelmet";

export default function EventEnded({ eventData }) {
  const { t, i18n } = useTranslation();

  if (!eventData) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    try {
      return new Intl.DateTimeFormat(i18n.language || "fr-FR", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(new Date(dateStr));
    } catch {
      return dateStr;
    }
  };

  const formatTime = (timeStr) => {
    if (!timeStr) return null;
    try {
      const [hours, minutes] = timeStr.split(":");
      const date = new Date();
      date.setHours(hours, minutes);
      return date.toLocaleTimeString(i18n.language || "fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return timeStr;
    }
  };

  const dateDisplay = eventData.type_event === "ponctuel"
    ? `${formatDate(eventData.date)}${eventData.time ? ` • ${formatTime(eventData.time)}` : ""}`
    : `${formatDate(eventData.date_start)} → ${formatDate(eventData.date_end)}`;

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4">
      <SeoHelmet
        title={t("event_ended.title", { title: eventData.title })}
        description={t("event_ended.description")}
        image={eventData.logo || "https://eventbycar.com/share.png"}
        url={`https://eventbycar.com/event/user/${eventData.id_user}`}
      />
      <div className="max-w-2xl w-full bg-gray-100 rounded-xl shadow p-6 text-center">
        {eventData.logo && (
          <img src={eventData.logo} alt={eventData.title} className="w-full h-48 object-cover rounded-md mb-4" />
        )}
        <h1 className="text-2xl font-bold mb-2 text-gray-800">{eventData.title}</h1>
        <div className="flex items-center justify-center text-gray-600 mb-1">
          <MapPinIcon className="w-4 h-4 mr-1" />
          <span>{eventData.location}</span>
        </div>
        <div className="flex items-center justify-center text-gray-600 mb-4">
          <CalendarIcon className="w-4 h-4 mr-1" />
          <span>{dateDisplay}</span>
        </div>
        <p className="text-lg text-gray-700 mb-4">
          {t("event_ended.message")}
        </p>
		<Link to="/">
		  <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded">
			{t("event_ended.cta")}
		  </button>
		</Link>
      </div>
    </div>
  );
}
